import { Link } from 'react-router-dom';

import { LogoSeal } from '../components/Logo';

/**
 * Página PÚBLICA de download e instalação do plugin do OBS.
 * Não exige login: o streamer pode baixar o plugin de qualquer máquina
 * (ex.: o PC da live) e só precisa da URL do overlay, copiada da dashboard.
 */
export function ObsPluginPage() {
  return (
    <main className="obs-page">
      <header className="obs-page__header">
        <LogoSeal size={40} />
        <div>
          <h1 className="obs-page__title">Plugin para OBS Studio</h1>
          <p className="obs-page__subtitle">Integre o Send Message à sua live em poucos minutos.</p>
        </div>
      </header>

      <div className="card">
        <h2 className="section-title section-title--first">O que o plugin faz</h2>
        <ul className="obs-page__list">
          <li>
            Cria automaticamente a fonte <strong>Send Message Overlay</strong> na cena atual do OBS,
            com a URL e o tamanho certos — é ela que mostra as mensagens/Pix na live, em tempo real.
          </li>
          <li>
            <strong>Verificar conexão</strong>: confirma de dentro do OBS que o token é válido e a
            qual criador o overlay está vinculado.
          </li>
          <li>
            <strong>Enviar alerta de teste</strong>: dispara um alerta de exemplo para conferir
            posição e tamanho, sem sair do OBS.
          </li>
        </ul>

        <div className="obs-page__downloads">
          <a className="button button--primary" href="/obs/send-message-obs-plugin.zip" download>
            Baixar pacote completo (.zip)
          </a>
          <a className="button button--ghost" href="/obs/send-message-overlay.lua" download>
            Baixar só o script (.lua)
          </a>
        </div>
        <p className="form__help">
          O pacote .zip inclui o script e um LEIA-ME com o passo a passo de instalação.
        </p>
      </div>

      <div className="card">
        <h2 className="section-title section-title--first">Instalação</h2>
        <ol className="overlay-config__steps">
          <li>Extraia o .zip (ou salve o .lua) em qualquer pasta do computador da live.</li>
          <li>
            No OBS Studio: <strong>Ferramentas → Scripts</strong> → botão <strong>+</strong> →
            selecione <code>send-message-overlay.lua</code>.
          </li>
          <li>
            Cole a <strong>URL do seu overlay</strong> — copie na dashboard, aba{' '}
            <strong>Overlay (OBS)</strong>.
          </li>
          <li>
            Clique em <strong>Criar/atualizar fonte do overlay</strong> e depois em{' '}
            <strong>Enviar alerta de teste</strong>. Pronto!
          </li>
        </ol>
        <p className="form__help">
          A URL do overlay é secreta. Se vazar, regenere o token na dashboard e atualize no script.
        </p>
      </div>

      <p className="obs-page__footer">
        Ainda não tem conta? <Link to="/cadastro">Crie sua conta de criador</Link> · Já é criador?{' '}
        <Link to="/dashboard">Abrir dashboard</Link>
      </p>
    </main>
  );
}
